import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import styles from './Header.module.css';
import { ProfileDropdown } from 'components/common/ProfileDropdown/ProfileDropdown';

export const Header = ({ onToggleSidebar }) => {
  const navigate = useNavigate();

  return (
    <header className={styles.header}>
      <div className="Headermain">
        <div className="header-left">
          <div className='Headerlogo' onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
            <img src="https://kochasoft.com/assets/images/kochasoft-light.svg" alt="Brand Logo" />
          </div>
          <div className="portal-title">
            Customer Engagement Center
          </div>
        </div>
        <div className="header-right">
          <div className="user-icon">
            <ProfileDropdown />
          </div>

        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  onToggleSidebar: PropTypes.func
};
